<template>
  <div v-if="question.branchingConfigured">
    <p class="branching-title">Branching</p>

    <template v-if="question.branchingOptions && question.type === 'MultiChoice' && question.multipleSelection === true && question.recursiveBranching === false">
      <div v-for="(option, index) in question.branchingOptions" :key="index">
        <div class="branching-option" v-if="option.optionIds && option.optionIds !== ''">
          <span class="multiValue-data">
            <span v-for="(optionId, optIndex) in option.optionIds" :key="optIndex">
              <span class="branching-text-val">{{ optionId.body }}</span>
              <span class="branching-text-val" v-if="optIndex !== option.optionIds.length - 1">and</span>
            </span>
          </span>
          <span class="arrow-division"></span>
          <span class="branching-text branching-text-left"> {{ findStepSequence(option.nextQuestionId) }}</span>
        </div>
      </div>
    </template>

    <template v-if="question.options && question.type === 'MultiChoice' && question.multipleSelection === true && question.recursiveBranching === true">
      <div v-for="(option, index) in question.options" :key="index">
        <div class="branching-option" v-if="option.nextQuestionIdList && option.nextQuestionIdList.length > 0">
          <span class="multiValue-data">
            <span class="branching-text-val">{{ option.body }}</span>
          </span>
          <span class="arrow-division"></span>
          <div>
            <span v-for="(optionId, optIndex) in option.nextQuestionIdList" class="right-step-recursive" :key="optIndex">
              <span class="branching-text branching-text-left"> {{ findStepSequence(optionId) }}</span>
            </span>
          </div>
        </div>
      </div>
    </template>
    <div v-if="question.type === 'MultiChoice' && question.multipleSelection === true && question.recursiveBranching === true">
      <p class="recursive-loop-text">
        <span>Once recursive loop is complete, </span>
        <span class="end-recursive-step">{{ findStepSequence(question.recursiveLoopEndQuestionId) }}</span>
      </p>
    </div>

    <template v-if="question.branchingOptions && question.branchingOptions !== '' && question.type !== 'MultiChoice'">
      <div class="branching-option" v-for="(option, index) in question.branchingOptions" :key="index">
        <span v-if="(question.type === 'Number' || question.type === 'CustomScale' || question.type === 'NumberScale') && option.endValue" class="branching-range-left">
          <span class="branching-text-val" v-html="option.startValue"></span>
          <span class="branching-text-val">-</span>
          <span class="branching-text" v-html="option.endValue"></span>
        </span>
        <span v-else class="branching-text" v-html="option.singleValue"></span>
        <span class="arrow-division"></span>
        <span class="branching-text branching-text-left"> {{ findStepSequence(option.nextQuestionId) }}</span>
      </div>
    </template>

    <template v-if="question.type === 'Image'">
      <div v-for="(optionImage, index) in question.languageImageOptions" :key="index">
        <div v-for="(option, oIndex) in optionImage.options" :key="oIndex">
          <span class="branching-option" v-if="option.nextQuestion !== 'default' && option.nextQuestion">
            <span><img class="col-lg-2 img-size" :src="pdf ? `data:image/png;base64,${option.base64ImgUrl}` : option.imageUrl" alt/></span>
            <span class="arrow-division"></span>
            <span class="branching-text branching-text-left"> {{ findStepSequence(option.nextQuestion) }}</span>
          </span>
        </div>
      </div>
    </template>

    <div class="branching-option" v-if="(question.branchingOptions && question.branchingOptions == '' && question.type !== 'MultiChoice' && question.recursiveBranching === false) || question.type === 'Text' || question.type === 'SurveyInstruction' || (question.type === 'Number' && question.branchingType === 'normal')">
      <span class="branching-text">Any answer</span>
      <span class="arrow-division"></span>
      <span class="branching-text branching-text-left"> {{ findStepSequence(question.nextQuestionId) }}</span>
    </div>

    <template v-if="question.options && question.options !== '' && question.type === 'MultiChoice' && question.multipleSelection === false">
      <div v-for="(option, index) in question.options" :key="index">
        <span class="branching-option" v-if="option.nextQuestion !== 'default'">
          <span class="branching-text" v-html="option.formattedBody"></span>
          <span class="arrow-division"></span>
          <span class="branching-text branching-text-left"> {{ findStepSequence(option.nextQuestion) }}</span>
        </span>
      </div>
    </template>

    <template v-if="question.options && question.options !== '' && question.type !== 'MultiChoice'">
      <div v-for="(option, index) in question.options" :key="index">
        <span class="branching-option" v-if="option.nextQuestion !== 'default' && option.nextQuestion">
          <span class="branching-text" v-html="option.formattedBody"></span>
          <span class="arrow-division"></span>
          <span class="branching-text branching-text-left"> {{ findStepSequence(option.nextQuestion) }}</span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import * as commonHelper from "@/components/services/common-helper";
export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    questions: {
      type: Array,
      required: true
    },
    pdf: {
      type: Boolean
    }
  },
  watch: {
    question: {
      deep: true,
      handler() {}
    }
  },
  methods: {
    findStepSequence(nextQuestion) {
      return commonHelper.branchingLogic(nextQuestion, this.questions);
    }
  }
};
</script>

<style>
.branching-title {
  font-size: 12px;
  line-height: 16px;
  color: #666669;
  font-weight: bold;
  text-decoration: underline;
  margin-top: 14px;
}

.branching-text {
  font-size: 12px;
  line-height: 16px;
  color: #666669;
  margin-right: 12px;
  white-space: nowrap;
}

.branching-text-val {
  font-size: 12px;
  line-height: 16px;
  color: #666669;
  margin-right: 4px;
  white-space: nowrap;
}

.branching-text-left {
  margin-left: 6px;
}

.arrow-division {
  height: 1px;
  align-self: stretch;
  flex-grow: 0;
  transform: rotate(-180deg);
  background-color: #666669;
  line-height: 1px;
  padding: 0;
  margin: 0;
  display: flex;
  width: 100%;
  position: relative;
  top: 8px;
}

.branching-option {
  display: flex;
  width: 300px;
  justify-content: space-between;
  margin-bottom: 12px;
}

.branching-range-left {
  display: flex;
}

.configureOuter {
  padding: 0px 8px;
  box-sizing: border-box;
}

.multiValue-data {
  display: flex;
  flex-wrap: wrap;
}

.right-step-recursive {
  display: block;
}
.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 120px;
  max-height: 120px;
  padding-left: 5px;
}
.end-recursive-step {
  font-weight: bold;
}
.recursive-loop-text {
  font-size: 12px;
  color: #666669;
}
</style>
